import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { 
  faTrashAlt, faFile, faEnvelope as faEnvelopeReg
} from '@fortawesome/free-regular-svg-icons'

import {
  faUser, faLock, faSignOutAlt, faCog, faChevronDown, faPowerOff, faIdBadge, 
  faUsers, faUserTie, faFileContract, faFileExcel, faFilePdf, faBook, faHome,
  faFileInvoice, faMailBulk, faBell, faArrowsAltH, faLongArrowAltDown,
  faLongArrowAltUp, faUserCog, faKey, faUserLock, faUserTag, faUserShield, 
  faGlobe, faPhoneSquare, faEnvelopeSquare, faTrash, faPrint, faDollarSign,
  faRecycle, faClipboard, faHandHoldingUsd, faMoneyCheckAlt, faShieldAlt, 
  faFileInvoiceDollar, faFileImport, faBuilding, faFileAlt, faFileExport,
  faChevronUp, faCashRegister, faEllipsisV, faEdit, faHandHolding, 
  faPlus, faFileImage, faList, faIdCard, faFolder, faEye, faPaperPlane, faBan, 
  faTools, faEnvelope, faExclamation
} from '@fortawesome/free-solid-svg-icons'

import {
  faGithub
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faUser, faLock, faSignOutAlt, faCog, faGithub, faChevronDown, faPowerOff, 
  faIdBadge, faUsers, faUserTie, faFileContract, faFileExcel, faFilePdf, faBook, 
  faHome, faFileInvoice, faMailBulk, faBell, faArrowsAltH, faLongArrowAltDown,
  faLongArrowAltUp, faUserCog, faKey, faUserLock, faUserTag, faUserShield, 
  faGlobe, faPhoneSquare, faEnvelopeSquare, faTrash, faPrint, faDollarSign,
  faRecycle, faTrashAlt, faClipboard, faHandHoldingUsd, faMoneyCheckAlt, 
  faShieldAlt, faFileInvoiceDollar, faFile, faFileImport, faBuilding, faFileAlt,
  faFileExport, faChevronUp, faCashRegister, faEllipsisV, faEdit, faHandHolding,
  faPlus, faFileImage, faList, faIdCard, faFolder, faEye, faPaperPlane, faBan, 
  faTools, faEnvelope, faExclamation, faEnvelopeReg
)

Vue.component('Fa', FontAwesomeIcon)